import {$} from '../jquery-definition.js';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
import 'flickity-bg-lazyload';
import 'jquery-match-height';

// make Flickity a jQuery plugin
Flickity.setJQuery( $ );
jQueryBridget( 'flickity', Flickity, $ );

$( '.owl-carousel' ).each( function() {
	var $this = $( this );


	var autoPlay = 6000;
	if ( $( window ).width() < 992 ) {
		autoPlay = false;
	}

	var $carousel = $this.flickity( {
		bgLazyLoad: 2,
		pageDots: false,
		prevNextButtons: true,
		selectedAttraction: 0.01,
		friction: 0.2,
		wrapAround: true,
		contain: true,
		autoPlay: autoPlay,
		cellAlign: 'left',
		adaptiveHeight: true,
		arrowShape: 'M13.3,50c0-1.3,0.7-2.7,1.3-3.3L61.3,0l7.3,7.3L25.9,50l42.7,42.7l-7.3,7.3L14.6,53.3C13.9,52,13.3,51.3,13.3,50z',
	} );
} );

$( '.post-carousel' ).each( function() {
	var $this = $( this );

	var $carousel = $this.flickity( {
		bgLazyLoad: 2,
		pageDots: false,
		prevNextButtons: true,
		selectedAttraction: 0.01,
		friction: 0.2,
		wrapAround: false,
		contain: true,
		cellAlign: 'left',
		adaptiveHeight: true,
		arrowShape: 'M13.3,50c0-1.3,0.7-2.7,1.3-3.3L61.3,0l7.3,7.3L25.9,50l42.7,42.7l-7.3,7.3L14.6,53.3C13.9,52,13.3,51.3,13.3,50z',
	} );
} );

$( '.external-posts-carousel' ).each( function() {
	var $this = $( this );

	var $carousel = $this.flickity( {
		bgLazyLoad: 2,
		pageDots: false,
		prevNextButtons: true,
		selectedAttraction: 0.01,
		friction: 0.2,
		wrapAround: false,
		contain: true,
		cellAlign: 'left',
		adaptiveHeight: false,
		arrowShape: 'M13.3,50c0-1.3,0.7-2.7,1.3-3.3L61.3,0l7.3,7.3L25.9,50l42.7,42.7l-7.3,7.3L14.6,53.3C13.9,52,13.3,51.3,13.3,50z',
	} );
} );

$( window ).load( function() {
	setTimeout( function() {
		window.dispatchEvent( new Event( 'resize' ) );
	}, 100 );
} );
